import dayjs from 'dayjs'
import { RANGE_TYPES } from '_services/insights-v2'

// will be set to report data and get stale
const YESTERDAY = dayjs().subtract(1, 'day').toISOString().split('T').at(0)
const ONE_YEAR_AGO = dayjs().subtract(1, 'year').toISOString().split('T').at(0)

export const BE_SOCIAL_CHANNELS = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  pinterest: 'Pinterest',
  reddit: 'Reddit',
  snapchat: 'Snapchat',
  twitch: 'Twitch',
  whatsapp: 'WhatsApp',
  twitter: 'X (formerly Twitter)',
  youtube: 'YouTube',
}

export const SLIDES_SCHEMA = [
  {
    template: 'Competitive_Landscape',
    data: {
      title: 'Competitive Landscape',
      description:
        'The users in this audience may have interest in similar products to yours. After understanding your audience’s behavior and interest, this competitive landscape helps you gain an understanding of your audience’s interest.',
      section_1: {
        title: 'COMPETITOR DISTRIBUTION (%):',
        subtitle: '(total events - last 30 days)',
        type: 'Topics',
      },
      section_2: {
        title: 'COMPETITOR SENTIMENT DISTRIBUTION (%):',
        subtitle: '(total events - last 30 days)',
        type: 'Topics',
      },
      selected_entities: [],
    },
    constraint: {
      min: 3,
      max: 5,
    },
  },
  {
    // DEPRECATED:
    template: 'Competitive_Landscape_Pie_Chart',
    data: {
      title: 'Competitive Landscape: Pie Chart',
      description:
        'The users in this audience may have interest in similar products to yours. After understanding your audience’s behavior and interest, this competitive landscape helps you gain an understanding of your audience’s interest.',
      section_1: {
        title: 'COMPETITOR DISTRIBUTION (%):',
        subtitle: '(total searches, clicks, and shares)',
        type: 'Topics',
      },
      selected_entities: [],
    },
    constraint: {
      min: 3,
      max: 5,
    },
  },
  {
    // DEPRECATED:
    template: 'Competitive_Landscape_Bar_Chart',
    data: {
      title: 'Competitive Landscape: Bar Chart',
      description:
        'The users in this audience may have interest in similar products to yours. After understanding your audience’s behavior and interest, this competitive landscape helps you gain an understanding of your audience’s interest.',
      section_1: {
        title: 'COMPETITOR SENTIMENT DISTRIBUTION (%):',
        subtitle: '(total searches, clicks, and shares)',
        type: 'Topics',
      },
      selected_entities: [],
    },
    constraint: {
      min: 3,
      max: 5,
    },
  },
  {
    template: 'Seasonality',
    data: {
      title: 'Recent Trends by Topics',
      description:
        'It is important to understand your audience’s interest over a period of time. This insight shows how your audience engages with certain topics, companies and entities over time. Your target audience is a highly engaged group and more likely to search, share, and click on topics of interest than the average ShareThis user. Gain a full understanding of your audience’s core characteristics and behaviors to build a focused and successful marketing campaign.',
      section_1: {
        // title: 'ENGAGEMENT BY WEEK:',
        // subtitle: '(total events)',
        type: 'Topics',
      },
      selected_entities: [],
      time_frame: 'week_of_year',
      time_range: {
        type: RANGE_TYPES.PAST_12,
        beginning: ONE_YEAR_AGO,
        end: YESTERDAY,
      },
      y_labels: 'Percent',
    },
    constraint: {
      min: 1,
      max: 5,
    },
    options: [
      {
        text: 'Daily',
        value: 'day_of_year',
      },
      {
        text: 'Weekly',
        value: 'week_of_year',
      },
      {
        text: 'Monthly',
        value: 'month_of_year',
      },
    ],
  },
  {
    template: 'Seasonality_by_Category',
    data: {
      title: 'Recent Trends by Category',
      description:
        'It is important to understand your audience’s interest over a period of time. This insight shows how your audience engages with certain categories over time. Your target audience is a highly engaged group and more likely to search, share, and click on categories of interest than the average ShareThis user. Gain a full understanding of your audience’s core characteristics and behaviors to build a focused and successful marketing campaign.',
      section_1: {
        // title: 'ENGAGEMENT BY WEEK:',
        // subtitle: '(total events)',
        type: 'Categories',
      },
      selected_entities: [],
      insights: [
        ['l2category', 'score'],
        ['l3category', 'score'],
      ],
      time_frame: 'week_of_year',
      time_range: {
        type: RANGE_TYPES.PAST_12,
        beginning: ONE_YEAR_AGO,
        end: YESTERDAY,
      },
      y_labels: 'Percent',
    },
    constraint: {
      min: 1,
      max: 5,
    },
    options: [
      {
        text: 'Daily',
        value: 'day_of_year',
      },
      {
        text: 'Weekly',
        value: 'week_of_year',
      },
      {
        text: 'Monthly',
        value: 'month_of_year',
      },
    ],
  },
  {
    template: 'Sentiment',
    data: {
      title: 'Competitive Sentiment',
      description:
        'The users in this audience may have interest in similar products to yours. After understanding your audience’s behavior and interest, this competitive landscape helps you gain an understanding of your audience’s interest.',
      section_1: {
        title: 'COMPETITOR SENTIMENT DISTRIBUTION (%):',
        subtitle: '(total events - last 30 days)',
        type: 'Topics',
      },
      selected_entities: [],
    },
    constraint: {
      min: 3,
      max: 5,
    },
  },
  {
    template: 'Audience_Trend',
    data: {
      title: 'Audience Trend',
      description:
        "Users in this audience express different social actions and levels of interest throughout the year. Heavy up your targeting around core peak engagement periods to attract the most attention from this audience and maximize your campaign's ROI.",
      hide_select: true,
      section_1: {
        // title: 'PERCENT OF EVENTS BY WEEK:',
        // subtitle: '(total events)',
        type: 'Segments',
      },
      selected_entities: [{}],
      selected_events: {
        total_events: false,
        searches: true,
        clicks: true,
        shares: true,
        page_views: true,
      },
      time_frame: 'week_of_year',
      time_range: {
        type: RANGE_TYPES.PAST_12,
        beginning: ONE_YEAR_AGO,
        end: YESTERDAY,
      },
      y_labels: 'Percent',
    },
    options: [
      {
        text: 'Daily',
        value: 'day_of_year',
      },
      {
        text: 'Weekly',
        value: 'week_of_year',
      },
      {
        text: 'Monthly',
        value: 'month_of_year',
      },
    ],
  },
  {
    template: 'Audience_Comparison',
    data: {
      title: 'Audience Comparison',
      description:
        'Compare online content consumption habits throughout the year among different audiences and verticals to determine the best time to reach your most engaged consumers.',
      section_1: {
        // title: 'ENGAGEMENT BY WEEK:',
        // subtitle: '(total events)',
        type: 'Segments',
      },
      selected_entities: [],
      time_frame: 'week_of_year',
      time_range: {
        type: RANGE_TYPES.PAST_12,
        beginning: ONE_YEAR_AGO,
        end: YESTERDAY,
      },
      y_labels: 'Percent',
    },
    constraint: {
      min: 2,
      max: 5,
    },
    options: [
      {
        text: 'Daily',
        value: 'day_of_year',
      },
      {
        text: 'Weekly',
        value: 'week_of_year',
      },
      {
        text: 'Monthly',
        value: 'month_of_year',
      },
    ],
  },
  {
    template: 'Entity_Comparison',
    data: {
      title: 'Engagement Comparison',
      description:
        "This insight allows you to see how your brand or product performs against your competitors' online presence.",
      section_1: {
        title: 'ENGAGEMENT DISTRIBUTION (%):',
        subtitle: '(total events - last 30 days)',
        type: 'Topics',
      },
      selected_entities: [],
    },
    constraint: {
      min: 3,
      max: 5,
    },
  },
  {
    template: 'L2_Categories_and_L3_Categories',
    data: {
      title: 'Passion Points',
      description:
        'Your audience has a diverse set of interests and passions. Leverage these segments in your marketing plan to not only expand your campaign’s scale and reach, but also reach ideal consumers in new and strategic ways.',
      section_1: {
        title: 'HIGHEST OVER-INDEXING LEVEL 2 AND LEVEL 3 CATEGORIES:',
        subtitle: '(total users - last 30 days)',
        footnote:
          'Index scores quantify how much more likely a user in this audience falls into a category compared to an average ShareThis user.',
        default_options: true,
        type: 'Categories',
      },
      selected_entities: [],
      insights: [
        ['l2category', 'score'],
        ['l3category', 'score'],
      ],
    },
  },
  {
    template: 'L2_and_L3_Categories_WordCloud',
    data: {
      title: 'Category Cloud',
      description:
        'Your audience has a diverse set of interests and passions. Leverage these segments in your marketing plan to not only expand your campaign’s scale and reach, but also reach ideal consumers in new and strategic ways.',
      section_1: {
        title: 'TOP OVER-INDEXING LEVEL 2 AND LEVEL 3 CATEGORIES:',
        subtitle: '(total events - last 30 days)',
        footnote:
          'Index scores quantify how much more likely a user in this audience falls into a category compared to an average ShareThis user.',
        default_options: true,
        type: 'Categories',
      },
      selected_entities: [],
      insights: [
        ['l2category', 'score'],
        ['l3category', 'score'],
      ],
    },
  },
  {
    template: 'Topics_Cloud',
    data: {
      title: 'Topics Cloud',
      description:
        'Your audience has a diverse set of interests and passions. Leverage these keywords in your marketing plan to not only expand your campaign’s scale and reach, but also reach ideal consumers in new and strategic ways.',
      section_1: {
        title: 'Topics most associated with the audience',
        subtitle: '(total events - last 30 days)',
        type: 'Topics',
      },
      selected_entities: [],
    },
    constraint: {
      min: 5,
      max: 20,
    },
  },
  {
    template: 'Data_Label',
    data: {
      title: 'IAB Data Label',
      description: 'none',
      section_1: {
        data_provider_contact: 'data@sharethis.com',
        segment_criteria: 'ShareThis collects...',
      },
    },
  },
  {
    template: 'Recommended_Segments',
    data: {
      title: 'Audiences To Activate',
      description:
        'Tap into ShareThis audiences to create a well-rounded and holistic campaign. Consider the following segments in your activation strategy.',
      section_1: {
        title: 'STANDARD',
        constraint: {
          max: 5,
        },
        type: 'Categories',
        selected_entities: [],
      },
      section_2: {
        title: 'OVER-INDEXING CATEGORIES',
        default_options: true,
        type: 'Categories',
        selected_entities: [],
      },
      section_3: {
        title: 'CUSTOM',
        note: 'Craft your own custom audiences using relevant signals such as:',
        signal_1: 'Signal 1',
        signal_2: 'Signal 2',
        signal_3: 'Signal 3',
        signal_4: 'Signal 4',
        signal_5: 'Signal 5',
      },
      insights: [
        ['l2category', 'score'],
        ['l3category', 'score'],
      ],
    },
  },
  {
    template: 'Marketing_1',
    data: {
      title: 'Marketing Slide 1',
    },
  },
  {
    template: 'Marketing_2',
    data: {
      title: 'Marketing Slide 2',
    },
  },
  {
    template: 'Marketing_3',
    data: {
      title: 'Marketing Slide 3',
    },
  },
  {
    template: 'Marketing_4',
    data: {
      title: 'Marketing Slide 4',
    },
  },
  {
    template: 'Marketing_5',
    data: {
      title: 'Marketing Slide 5',
    },
  },
  {
    template: 'Marketing_6',
    data: {
      title: 'Marketing Slide 6',
    },
  },
  {
    template: 'Transition',
    data: {
      title: 'Transition Slide',
    },
  },
  {
    template: 'Intro',
    data: {
      title: 'Intro Slide',
      section_1: {
        title: 'Intro Slide Title',
        name: 'Name',
      },
    },
  },
  {
    template: 'ShareThis_Overview',
    data: {
      title: 'ShareThis Overview',
    },
  },
  {
    template: 'Device_and_Mobile_OS',
    data: {
      title: 'Device Usage',
      description:
        'All users have personal preferences for where they like to browse, learn, and shop online. Heavy up your advertising on the devices and operating systems that your ideal consumers spend most of their time on.',
      section_1: {
        title: 'DEVICE DISTRIBUTION (%):',
        subtitle: '(total users - last 12 months)',
      },
      section_2: {
        title: 'MOBILE DISTRIBUTION (%):',
        subtitle: '(total users - last 12 months)',
      },
      insights: [
        ['device', 'percent'],
        ['mobile_os', 'percent'],
      ],
    },
  },
  {
    template: 'Social_Networks',
    data: {
      title: 'Preferred Social Channels',
      description:
        'People are motivated to share content that evokes a sense of passion and excitement — on channels that speak to the right audience. These trends provide insight into the types of topics your consumers are most interested in and how they are engaging with content online.',
      section_1: {
        title: 'SOCIAL CHANNEL DISTRIBUTION (%):',
        subtitle: '(total events - last 30 days)',
      },
      insights: [['social_network', 'percent']],
      selected_channels: Object.keys(BE_SOCIAL_CHANNELS).map((channel) => channel.toLowerCase()),
    },
  },
  {
    template: 'Top_Indexing_States',
    data: {
      title: 'Top U.S. States',
      description:
        'Where in the U.S. are your consumers actively engaging with content? Heavy up your geo-targeting in these specific states to reach those with the highest levels of interest and intent.',
      section_1: {
        title: 'HIGHEST OVER-INDEXING U.S. STATES:',
        subtitle: '(total users - last 30 days)',
        footnote:
          'Index scores quantify how much more likely a user in this audience consumes content in a U.S. state compared to an average ShareThis user.',
      },
      insights: [['states', 'overindex']],
    },
  },
  {
    template: 'Audience_Overview',
    data: {
      title: 'Audience Overview',
      description:
        "Your target audience is a highly engaged group and more likely to search, share and click on topics of interest than the average ShareThis user. Gain a full understanding of your audiences' core characteristics and behaviors to build a focused and successful marketing campaign.",
      section_1: {
        title: 'DEMOGRAPHICS DISTRIBUTION (%):',
        subtitle: '(percent of users - last 30 days)',
      },
      section_2: {
        title: 'AGE DISTRIBUTION (%):',
        subtitle: '(percent of users - last 30 days)',
      },
    },
  },
  {
    template: 'Income_Distribution',
    data: {
      title: 'Audience Demographics: Income Distribution',
      description:
        "Your target audience is a highly engaged group and more likely to search, share and click on topics of interest than the average ShareThis user. Gain a full understanding of your audiences' core characteristics and behaviors to build a focused and successful marketing campaign.",
      section_1: {
        title: 'INCOME DISTRIBUTION (%):',
        subtitle: '(percent of users - last 30 days)',
      },
    },
  },
  {
    template: 'Income_Distribution_by_Age_and_Gender',
    data: {
      title: 'Audience Demographics: Income Distribution by Age and Gender',
      description:
        "Your target audience is a highly engaged group and more likely to search, share and click on topics of interest than the average ShareThis user. Gain a full understanding of your audiences' core characteristics and behaviors to build a focused and successful marketing campaign.",
      section_1: {
        title: 'INCOME DISTRIBUTION BY AGE (%):',
        subtitle: '(percent of users - last 30 days)',
      },
      section_2: {
        title: 'INCOME DISTRIBUTION BY GENDER (%):',
        subtitle: '(percent of users - last 30 days)',
      },
    },
  },
  {
    template: 'Income_Distribution_by_Age',
    data: {
      title: 'Audience Demographics: Income by Age',
      description:
        "Your target audience is a highly engaged group and more likely to search, share and click on topics of interest than the average ShareThis user. Gain a full understanding of your audiences' core characteristics and behaviors to build a focused and successful marketing campaign.",
      section_1: {
        title: ' INCOME BY AGE (%):',
        subtitle: '(percent of users - last 30 days)',
      },
    },
  },
  {
    template: 'Income_Distribution_by_Gender',
    data: {
      title: 'Audience Demographics: Income by Gender',
      description:
        "Your target audience is a highly engaged group and more likely to search, share and click on topics of interest than the average ShareThis user. Gain a full understanding of your audiences' core characteristics and behaviors to build a focused and successful marketing campaign.",
      section_1: {
        title: ' INCOME BY GENDER (%):',
        subtitle: '(percent of users - last 30 days)',
      },
    },
  },
  {
    template: 'Outro',
    data: {
      title: 'Outro Slide',
      section_1: {
        title: 'Thank You!',
        name: 'Name',
        email: 'Email Address',
      },
    },
  },
]
